import { _tableLogActivity } from "lib/Helper";
import Action from "./Action";
import { SettingOutlined } from "@ant-design/icons";

const columns = (action, modalForm, modalDelete) => [
  {
    title: 'No',
    dataIndex: 'rownum',
    width: '5%',
  },
  {
    title: 'Nama Module',
    dataIndex: 'whatsapp_modul_name',
    render: (text, row) => text || "-",
  },
  {
    title: 'Nomor WhatsApp',
    dataIndex: 'whatsapp_phone_integration_number',
    render: (text) => text || "-",
  },
  {
    title: 'LogActivity',
    key: 'logactivity',
    width: '10%',
    render: (a, row) => _tableLogActivity(row),
  },
  {
    title: <SettingOutlined />,
    align: "center",
    key: 'operation',
    width: '5%',
    render: (a, row) => (
      <Action
        row={row}
        action={action}
        modalForm={modalForm}
        modalDelete={modalDelete}
      />
    ),
  },
];

export default columns;
